import React from 'react'
import PropTypes from 'prop-types'

import { THEME } from '../../../core/constants'

import { DEFINE, QC, QQA, TASK_VIEW_TYPES } from '../../constants'

const getViewColor = type => {
  switch (type) {
    case DEFINE:
      return THEME.colors.taskViewDefine
    case QC:
      return THEME.colors.taskViewQc
    case QQA:
      return THEME.colors.taskViewQqa
    default:
      return THEME.colors.greyBlue
  }
}

const TaskResolveMessage = ({ currentViewType, style }) => (
  <span style={style}>
    Are you sure you want to resolve this task in{' '}
    <span style={{ fontWeight: 'bold', color: getViewColor(currentViewType) }}>
      {TASK_VIEW_TYPES[currentViewType]?.name} view
    </span>
    ?
  </span>
)

TaskResolveMessage.propTypes = {
  currentViewType: PropTypes.string.isRequired,
  style: PropTypes.object,
}

TaskResolveMessage.defaultProps = {
  style: {},
}

export default TaskResolveMessage
